<template>
  <b-modal
    :id="modalId"
    size="lg"
    scrollable
    no-close-on-esc
    no-close-on-backdrop
    class="modal-body"
  >
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <TitleSetting :tag="'div'" :label="$t('engine.sidebar.widget.slide.manageTab.modal.lblSelectSlideTemplate', languageEngine)" />
        <div style="display: flex; gap: 10px;">
          <span style="vertical-align: middle">
            <i class="fal fa-question-circle"></i>
          </span>
          <div
            @click="cancelHandle"
            type="button"
            aria-label="Close"
            id="close-modal-add-slide"
            class="close-modal"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </template>

    <template>
      <div class="setting-slide">
        <div class="thumbnail-wrapper">
          <div class="thumbnail" v-for="(preset, preset_index) in presetsSlide" :key="`slide_preset_${preset_index}`" :class="{'active': templateSelected == preset.id}" @click="setSlideLayout(preset.id)" >
            <img  :src="preset.thumbnailUrl" />
            <img class="thumbnail-hover" v-if="preset.thumbnailHoverUrl" :src="preset.thumbnailHoverUrl" />
          </div>
        </div>
      </div>
    </template>

    <template #modal-footer>
      <b-button variant="blue" class="mr-2" @click="save($event)">
        <i class="far fa-check"></i> {{ $t('engine.sidebar.widget.slide.manageTab.lblAddSlide', languageEngine) }}
      </b-button>
      <b-button variant="secondary" @click="cancelHandle()">
        <i class="far fa-times"></i> {{ $t('engine.common.btnCancel', languageEngine) }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import TitleSetting from "@components_system/Shared/Elements/Texts/TitleSetting";

export default {  
  components: {
    TitleSetting,
  },  
  props: {
    
  },
  data() {
    return {
      modalId: "modal-add-slide",
      default: {
        presetKey: 'preset_slide_page_0007',
      },
      templateSelected: null,
    };
  },
  computed: {
    ...mapGetters({
      modal: "design/modal",
      modalPayload: "design/modalPayload",
      activeSection: "design/component/activeSection",
      components: "design/metadata/components",
      presets: "design/component/presetsOther",
      elActiveParentID: "design/component/elActiveParentID",
      languageEngine: "design/userPreference/languageEngine",
    }),
    component() {
      return this.activeSection.id && this.components[this.activeSection.id]
    },
    presetsSlide() {
      return (
        this.presets.slide_page &&
        this.presets.slide_page.selectLayout
      );
    },
  },
  watch: {
    modal: {
      async handler() {
        if (this.modal == this.modalId) {
          this.$bvModal.show(this.modalId);
          if (!this.presets.slide_page) {
            await this.$store.dispatch("design/component/loadPreset", {
              type: 'slide_page',
              metaName: 'other',
            });
          }
          this.defaultSlideLayout();
        }
      },
    },
  },
  methods: {
    save(evt) {
      evt.preventDefault();

      if (!this.templateSelected) {
        this.defaultSlideLayout();
      }

      this.$store.dispatch("design/component/setPresetRender", {
        id: this.templateSelected,
        metaName: "other",
      });

      this.cancelHandle();
    },
    defaultSlideLayout() {
      if (
        !this.templateSelected && 
        this.presets && this.presets.slide_page && this.presets.slide_page.selectLayout.length > 0
      ) {
        let preset;
        
        if (!preset) {
          preset = this.presets.slide_page.selectLayout.find((item => {
            return item.key == this.default.presetKey; // blank 01
          }));
        }

        if (!preset) {
          preset = this.presets.slide_page.selectLayout[0];
        }

        if (preset) this.templateSelected = preset.id;
      }
    },
    setSlideLayout(value) {
      this.templateSelected = value;
    },
    cancelHandle() {
      this.templateSelected = null;
      this.$bvModal.hide(this.modalId);
      this.$store.dispatch("design/setModal", { name: "" });
    },
  },
};
</script>

<style lang="scss">
#modal-add-slide {
  .slick-track {
    width: 100% !important;
  }
  .modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 30px;
    min-height: 250px;
  }
  .thumbnail-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    .thumbnail {
      position: relative;
      align-self: center;
      cursor: pointer;
      width: 31.33%;
      > img {
        width: 100%;
      }
      > div {
        width: 100% !important;
        margin: 0 !important;
        svg {
          width: 100%;
          height: 100%;
        }
      }
      .thumbnail-hover {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
      }
      &.active, &:hover {
        outline: 2px solid #12a9ff;
        box-shadow: 0px 0px 6px 2px rgba(36, 190, 226, 0.25);
        .thumbnail-hover {
          display: inline;
        }
        div {
          [fill="#DEE3E6"]{
            fill: #BDEBF6;
          }
        }
      }
    }
  }
}
</style>
